// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag[data-v-68962034]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;font-size:0}.tag__icon[data-v-68962034]{margin-right:4px}.tag__name[data-v-68962034]{font-weight:700;color:#8c4ddf}.tag[data-v-68962034]:hover .tag__icon svg{fill:#a363ff}.tag:hover .tag__name[data-v-68962034]{color:#a363ff}", ""]);
// Exports
module.exports = exports;
